// @ngInject
function importFinalizationDialogService($uibModal) {

    return {
        showDialog: showDialog
    };

    function showDialog() {

        var modalDefaults = {
            backdrop: true,
            keyboard: true,
            controller: 'importFinalizationDialogController as vm',
            // templateUrl: 'main/product/productimporteditor/components/dialogs/importFinalizationDialog.tpl.html',
            templateUrl: 'services/dialogs/importFinalizationDialog/importFinalizationDialog.tpl.html',
            size: 'md'
        };
        
        return $uibModal.open(modalDefaults).result;
    }
}

// @ngInject
function importFinalizationDialogController($uibModalInstance) {
    var vm = this;

    vm.selectionChoices = [
        {
            label:"productimport.nopriceupdate",
            selection: 'None'
        },
        {
            label:"productimport.updatesamecolor",
            selection: 'Color'
        },
        // { // Disabled until further notice
        //     label:"productimport.updateallvariants",
        //     selection: 'AllVariants'
        // }
    ];
    vm.selected = vm.selectionChoices[0];

    console.log("FinalizationModal opened");

    vm.closeModal = closeModal;

    function closeModal() {
        $uibModalInstance.close(vm.selected.selection);
    }
}

angular
    .module('services.dialogs.importFinalizationDialog', [])
    .service('importFinalizationDialogService', importFinalizationDialogService)
    .controller('importFinalizationDialogController', importFinalizationDialogController);